import React, { useEffect, useState } from "react";
import { AuthNav } from "../../../components/Navbar/Webpages/AuthNav";
import { SideNav } from "../../../components/Navbar/Webpages/AuthNav";
import { RegisterButton } from "../../../components/Buttons";
import { AiFillCopy } from "react-icons/ai";
import { UploadForm } from "../../../components/Upload";
import {
  getInvestmentRequest,
  createPaymentRequest,
  clearCreatePaymentSuccess,
} from "../../../redux/action";
import { useFormik } from "formik";
import * as yup from "yup";
import toast from "react-hot-toast";
import { CircularProgress } from "@material-ui/core";
import CurrencyDisplay from "../../../components/Currency/CurrencyDisplay";
import { useDispatch, useSelector } from "react-redux";
import { useHistory } from "react-router-dom";
import { useParams } from "react-router";

const Payment = () => {
  const dispatch = useDispatch();
  const { id } = useParams();
  const history = useHistory();

  const copyToClipboard = () => {
    navigator.clipboard.writeText(`bc1qdjkh6wd8yve2fc57ch63wshecfpla0q9k7eszj`);

    toast.success("Copied", {
      duration: 3000,
    });
  };

  const {
    getInvestmentSuccess,
    getInvestmentError,
    getInvestmentLoading,
    user,
    plans,
    investment,
    createPaymentLoading,
    createPaymentSuccess,
    createPaymentError,
  } = useSelector((state) => {
    const {
      success: {
        getInvestment: getInvestmentSuccess,
        createPayment: createPaymentSuccess,
      },
      errors: { getInvestment: getInvestmentError, createPaymentError },
    } = state.ajaxStatuses;

    const { getInvestmentLoading, createPaymentLoading } =
      state.loadingIndicator;

    const { user } = state.userData;
    const { plans } = state.planData;
    const { investment } = state.investmentData;

    return {
      getInvestmentSuccess,
      getInvestmentError,
      getInvestmentLoading,
      user,
      plans,
      investment,
      createPaymentLoading,
      createPaymentSuccess,
      createPaymentError,
    };
  });

  const formik = useFormik({
    initialValues: {
      imgReceiptUrl: "",
    },
    validationSchema: yup.object({}),

    onSubmit: (prop) => {
      if (prop.imgReceiptUrl === "") {
        toast.error("Upload a receipt", {
          duration: 3000,
        });
      } else {
        prop.amount = investment.amount;
        prop.user = user._id;
        prop.investment = investment._id;

        dispatch(createPaymentRequest(prop));
      }
    },
  });

  useEffect(() => {
    dispatch(getInvestmentRequest(id));
  }, [dispatch, id]);

  useEffect(() => {
    if (getInvestmentError) {
      toast.error(getInvestmentError, {
        duration: 3000,
      });
    }
  }, [getInvestmentError]);

  useEffect(() => {
    if (createPaymentError) {
      toast.error(createPaymentError, {
        duration: 3000,
      });
    }
  }, [createPaymentError]);

  useEffect(() => {
    if (createPaymentSuccess) {
      toast.success(createPaymentSuccess, {
        duration: 3000,
      });

      history.push(`/dashboard/`);

      dispatch(clearCreatePaymentSuccess());
    }
  }, [createPaymentSuccess]);

  return (
    <div className=" h-screen overflow-y-scroll">
      <AuthNav />
      <SideNav />
      <div>
        {getInvestmentLoading ? (
          <div className="text-center  col-span-3 justify-self-center align-self-center my-36">
            {" "}
            <CircularProgress size="20px" />
          </div>
        ) : (
          <div className="container max-w-screen-xl mx-auto px-3 pt-5 pb-16">
            <div className="lg:mt-4  md:mx-auto mt-8 mx-4">
              <div className="shadow  py-4 px-4 md:px-8 md:py-8  ">
                <div className="text-lg text-center">
                  Please proceed to make deposite of crypto worth $
                  {investment.amount} to the wallet address below and upload
                  proof of payment
                </div>
                <div className="py-2  text-center text-sm bg-green-900  mt-3 md:w-80 mx-auto">
                  Payments will be confirmed after verification.
                </div>
                <form onSubmit={formik.handleSubmit} className="grid gap-8 ">
                  <div className="grid  grid-cols-1  md:grid-cols-2 gap-x-8 pt-8">
                    <div>
                      <div
                        onClick={copyToClipboard}
                        className="relative cursor-pointer"
                      >
                        <input
                          type="text"
                          className=" py-2 px-4   border border-darkNav flex-grow  focus:outline-none placeholder-gray-200::placeholder placeholder-opacity-75 w-full "
                          placeholder="Amount"
                          name="usernameOrEmail"
                          value={"bc1qdjkh6wd8yve2fc57ch63wshecfpla0q9k7eszj"}
                        />
                        <AiFillCopy className="absolute text-xl top-3 right-4" />
                      </div>
                      <div className="pt-4">
                        <img
                          src="/img/dashboard/qrcode.jpg"
                          alt=""
                          className=" w-56 h-56  mx-auto"
                        />
                        <div className="text-xl text-center mt-2">
                          Scan for wallet address
                        </div>
                      </div>
                    </div>

                    <div>
                      <div className=" grid grid-cols-3 gap-2">
                        <div className="  border border-darkNav p-2">
                          <p>Payment</p>
                          <p>
                            <CurrencyDisplay
                              usdAmount={investment.amount}
                              className="inline"
                            />
                          </p>
                        </div>
                        <div className="  border border-darkNav p-2">
                          <p>Profit</p>
                          <p>
                            <CurrencyDisplay
                              usdAmount={investment.profitProduction}
                              className="inline"
                            />
                          </p>
                        </div>
                        <div className="  border border-darkNav p-2">
                          <p>Payout</p>
                          <p>
                            <CurrencyDisplay
                              usdAmount={investment.expectedReturn}
                              className="inline"
                            />
                          </p>
                        </div>
                      </div>
                      <div className="pt-2">
                        <UploadForm formik={formik} />
                      </div>
                    </div>
                  </div>

                  <div className="flex flex-col w-full md:w-80 mt-2 mx-auto">
                    <RegisterButton
                      loading={createPaymentLoading}
                      disable={!(formik.dirty && formik.isValid)}
                      action={formik.handleSubmit}
                      text="Proceed"
                    />
                  </div>
                </form>
              </div>
            </div>
          </div>
        )}
      </div>
    </div>
  );
};

export default Payment;
